import { Box, Container, Grid, Typography } from '@mui/material';
import { getDictionary, getField } from '@/app/utils/translation/translation';
import { getSvg } from '@/app/utils/svgUtils';
import React from 'react';

function VideoPlayer({ language, translations }) {
  const dictionary = getDictionary(translations, 'custom-app', language);
  const [isMobile, setIsMobile] = React.useState(false);
  const [isTablet, setIsTablet] = React.useState(false);
  const isArabic = language === 'arabic'
  React.useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 699) {
        setIsMobile(true);
        setIsTablet(false);
      } else if (width >= 700 && width <= 1024) {
        setIsMobile(false);
        setIsTablet(true);
      } else {
        setIsMobile(false);
        setIsTablet(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getImageStyles = () => {
    if (isMobile) {
      return { width: '2rem', height: 'auto' };
    }
    if (isTablet) {
      return { width: '4rem', height: 'auto' };
    }
    return { width: '7rem', height: 'auto' };
  };
  const getNumbersStyles = () => {
    if (isMobile) {
      return { fontSize: "1rem" };
    }
    if (isTablet) {
      return { fontSize: "2rem" };
    }
    return { fontSize: "3rem" };
  };
  const getTextStyles = () => {
    if (isMobile) {
      return { fontSize: "0.5rem", width: "60px" };
    }
    if (isTablet) {
      return { fontSize: "1rem", width: "120px" };
    }
    return { fontSize: "1.2rem", width: "160px" };
  };

  return (
    <>

      <div style={{ position: 'relative', zIndex: 1 }}>
        <Typography variant={isMobile ? "h3" : "h2"} textAlign={"center"} sx={{ color: "var(--text-primary)" }} fontWeight={"bold"} fontFamily={"Century Gothic"}>
          {getField(dictionary, 'title', language)}
        </Typography>
        <div style={{ marginLeft: "30%" }}>
          {getSvg('arrowDownIcon', { mainPurple: 'var(--accent-primary)' }, { width: isMobile ? "50px" : "90px", height: isMobile ? "50px" : "120px" }, {
            position: 'absolute'
          })}
        </div>
        </div>

      <div style={{ display: 'flex', alignItems: 'center', textAlign: "center", justifyContent: "center", marginTop: "2rem" }}>
        <div style={{ position: "relative", width: isMobile ? "100%" : "80%", height: "auto", marginTop: isMobile ? '0rem' : "2rem" }}>
          <video
            style={{ width: "100%", height: "auto" }}
            autoPlay
            muted
            loop
            playsInline
            controls={false}
          >
            <source src="/assests/videos/appdesign.mp4" type="video/mp4" loading="lazy"/>
          </video>

          <div
            style={{
              position: "absolute",
              top: "1rem",
              left: "1rem",

            }}
          >
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <img
                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/color-circle.svg`}
                style={getImageStyles()}
                alt="Color Circle"
                loading="lazy"

              />
            </div>
            <div style={{ gap: isMobile || isArabic ? '0rem' : "1rem", display: "flex", alignItems: "center", justifyContent: "space-around", marginTop: "0.5rem", fontWeight: "bold" }}>
              <div style={getNumbersStyles()}> 1 </div>
              <div style={getTextStyles()}>  {getField(dictionary, 'choose-your-brand-colors', language)} </div>
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "1rem",
              left: "1rem",

            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              {getSvg('group10571Icon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, getImageStyles(), {})}

            </div>

            <div style={{ gap: isMobile || isArabic ? '0rem' : "1rem", display: "flex", alignItems: "center", justifyContent: "space-around", marginTop: "0.5rem", fontWeight: "bold" }}>
              <div style={getNumbersStyles()}>2</div>
              <div style={getTextStyles()} >{getField(dictionary, 'your-icons-style', language)}</div>
            </div>


          </div>
          <div
            style={{
              position: "absolute",
              top: "1rem",
              right: "1rem",

            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/brightness-and-contrast.svg`}
                style={getImageStyles()}
                alt='brightness'
                loading="lazy"
              />
            </div>
            <div style={{ gap: isMobile || isArabic ? '0rem' : "1rem", display: "flex", alignItems: "center", justifyContent: "space-around", marginTop: "0.5rem", fontWeight: "bold" }}>
              <div style={getNumbersStyles()}>3</div>
              <div style={getTextStyles()}>{getField(dictionary, 'dark-and-light-mode', language)}</div>
            </div>

          </div>
          <div
            style={{
              position: "absolute",
              bottom: "1rem",
              right: "1rem",

            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/background.svg`}
                style={getImageStyles()}
                alt='background'
                loading="lazy"
              />
            </div>
            <div style={{ gap: isMobile || isArabic ? '0rem' : "1rem", display: "flex", alignItems: "center", justifyContent: "space-around", marginTop: "0.5rem", fontWeight: "bold" }}>
              <div style={getNumbersStyles()}>4</div>
              <div style={getTextStyles()}>{getField(dictionary, 'background-image', language)} </div>
            </div>

          </div>
        </div>
      </div>




    </>

  );
}

export default VideoPlayer;
